module.exports = __webpack_public_path__ + "img/pick3.b027180a.png";